import React from 'react';
import PropTypes from 'prop-types';

import {
  TextBlock,
  ImageText,
  ImageBlock,
  VideoBlock,
  ImageSlider,
  ImageBanner,
  TwoColumnText,
  News,
  TimelineCarousel,
  Accordion,
  StaffGrid,
  OurStaff,
  ThreeColumnText,
  Advertising,
  Sponsors,
  ImageCarousel,
  ImageGrid,
  UpcomingEvents,
  EventCards,
  CardSlider,
  FeatureBanner,
} from '@blocks';

const BlockZone = ({ blocks }) => {
  const block = blocks.map((block, i) => {
    switch (block._type) {
      case 'textBlock':
        return <TextBlock key={i} {...block} />;
      case 'imageText':
        return <ImageText key={i} {...block} />;
      case 'imageBlock':
        return <ImageBlock key={i} {...block} />;
      case 'videoBlock':
        return <VideoBlock key={i} {...block} />;
      case 'imageSlider':
        return <ImageSlider key={i} {...block} />;
      case 'imageBanner':
        return <ImageBanner key={i} {...block} />;
      case 'twoColumnText':
        return <TwoColumnText key={i} {...block} />;
      case 'news':
        return <News key={i} {...block} />;
      case 'timelineCarousel':
        return <TimelineCarousel key={i} {...block} />;
      case 'accordion':
        return <Accordion key={i} {...block} />;
      case 'staffGrid':
        return <StaffGrid key={i} {...block} />;
      case 'ourStaff':
        return <OurStaff key={i} {...block} />;
      case 'threeColumnText':
        return <ThreeColumnText key={i} {...block} />;
      case 'sponsors':
        return <Sponsors key={i} {...block} />;
      case 'advertising':
        return <Advertising key={i} {...block} />;
      case 'imageCarousel':
        return <ImageCarousel key={i} {...block} />;
      case 'imageGrid':
        return <ImageGrid key={i} {...block} />;
      case 'upcomingEvents':
        return <UpcomingEvents key={i} {...block} />;
      case 'eventCards':
        return <EventCards key={i} {...block} />;
      case 'cardSlider':
        return <CardSlider key={i} {...block} />;
      case 'featureBanner':
        return <FeatureBanner key={i} {...block} />;
      default:
        return null;
    }
  });
  return <>{block}</>;
};

BlockZone.propTypes = {
  blocks: PropTypes.array.isRequired,
};

export default BlockZone;
